module.exports = __webpack_public_path__ + "fonts/Muli-Bold.a3e557a0.woff2";